<template>
  <div class="result">
    <p class="result-title">
      <img src="@/assets/images/text_result.svg" alt="あなたと近い肌タイプの方のレビュー" />
    </p>
    <p class="result-text">投稿いただいたスキンケア・ベースメイク商品のレビューから、<br class="pc">1商品あたり最大5件を表示しております。</p>
    <div class="result-scroll" :class="{'is-absolute': isFooterShow}">
      <p class="result-scroll-text"><img src="@/assets/images/scroll.svg" alt="SCROLL" /></p>
    </div>
    <part-retry :isAbsolute="scroll.isScrolledVueArea" @clickedButton="clickedRetry" :is-footer-show="isFooterShow" />
    <sort-result-sort ref="sort" :conditions="conditions" @selectedChoices="sortSelect" @sortChoices="sortChoices" @searchReview="searchReview" />
    <div class="result-wrap" >
      <div
        class="result-item"
        v-for="(item, index) in resultData"
        :key="`first-${index}`"
      >
        <sort-result-product2 :item="item" :index="index" />
        <div
          class="result-comments"
          :class="[
            {'result-comments--view': item.comment_all_view},
            {'result-comments--multiple': item.review.length > 1}
          ]"
        >
          <div
            class="result-comments-comment"
            v-for="(comment, index) in item.review"
            :key="`second-${index}`"
          >
            <sort-result-comment2 :key="`third-${index}`" :item="comment" :isSP="isSP"  />
          </div>
          <button
            v-if="item.review.length > 1 && !item.comment_all_view"
            class="result-comments-more"
            @click="moreReview(item,index)"
            v-text="'この商品のレビューをもっと見る'"
          />
        </div>
      </div>
      <button class="moreApiBtn">続きを見る</button>
      <div :class="{'is-active': showLoading}" class="result-loading">
        <div class="result-loading-dot result-loading-dot--1" />
        <div class="result-loading-dot result-loading-dot--2" />
        <div class="result-loading-dot result-loading-dot--3" />
      </div>
      <template v-if="resultData.length === 0 && !showLoading">
        <p class="result-nothing">該当のレビューが存在しません</p>
        <button class="result-nothing-button" @click="clickedRetry">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.77 13" class="result-nothing-button-arrow">
            <path class="cls-1" d="M5.88,0A5.89,5.89,0,0,0,0,5.88a.57.57,0,1,0,1.13,0,4.75,4.75,0,1,1,4.75,4.75H3.29l.27-.26a.58.58,0,0,0,0-.81.57.57,0,0,0-.8,0L1.53,10.8a.57.57,0,0,0,0,.8l1.23,1.23a.58.58,0,0,0,.4.17.56.56,0,0,0,.4-.17.57.57,0,0,0,0-.8l-.27-.26H5.88A5.89,5.89,0,1,0,5.88,0Z"/>
          </svg>
          <span class="result-nothing-button-text">やり直す</span>
        </button>
      </template>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { BRAND, SKINCARE, BASE, ORDER, WORRIES, SKIN_TYPE, MAKE_FREQUENCY, AGE } from '@/config/sortConditions.js';

import PartRetry from './PartRetry.vue';
import SortResultSort from './SortResultSort.vue';
import SortResultProduct2 from './SortResultProduct2.vue';
import SortResultComment2 from './SortResultComment2.vue';

export default {
  components: { PartRetry, SortResultSort, SortResultProduct2, SortResultComment2 },
  name: 'PageSortResult',
  props: {
    selectedStatus: {
      type: Object
    },
    list: {
      type: Array
    },
    isFooterShow: {
      type: Boolean,
      default: false
    },
    // master: {
    //   type: Object
    // },
    isSP: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      pageNum: 1, // レビューAPIページ番号

      resultData: [], // 結果データ
      resultDataMoreShowReviewFlgs: [], // 結果データの2件以上レビュー表示フラグ

      maxReviewCountPerPool: 5, // 1商品あたりの表示レビュー数
      poolCountPerView: 10, // 1画面あたりの表示商品数
      validCategories: ['スキンケア','ベースメイク'], // 有効なカテゴリー

      
      isShowResult: false,
      isLockApi: false,

      showLoading: false,
      moreApiEnd: false,
      
      scrollPosition: 0,
      onUpdateProcessing: null,


      conditions: {
        brand: BRAND,
        skincare: SKINCARE,
        base: BASE,
        order: ORDER,
        select1: WORRIES,
        select2: SKIN_TYPE,
        select3: MAKE_FREQUENCY,
        select4: AGE
      },


      scroll: {
        triggerY: 0,
        windowY: 0,
        windowHeight: 0,
        eventRunning: false,
        eventRunningFixed: false,
        scrolledEllement: 1,
        footerY: 0,
        isScrolledVueArea: false,
        isRunnungScrollFixed: false
      },
      
      preformedList: [],
      splitPreformedList: [],
      isSortOrder: false,
    };
  },
  computed: {
    selectedOrderID() {
      const _selectedIndex = this.conditions.order.findIndex(item => item.selected === true);
      return this.conditions.order[_selectedIndex].id;
    },
    headerHeight() {
      return this.isSP ? 61 : 124;
    },
  },
  mounted() {
    this.initializeScrollHandler();
  },
  methods: {


    /**
     * APIデータ一覧を初期化する
     */
    searchReview() {
      console.log('searchReview');
      // alert('searchReview');

      this.pageNum = 1;
      this.resultData = [];
      this.moreApiEnd = false;
      this.isShowResult = false;

      // スクロールでAPIを追加取得呼び出す時に位置がズレるのを防ぐ
      window.scroll({top: 0, behavior: 'smooth'});
      this.getApiData();
    },
    
    
    
    /**
     * APIへ送るパラメータを返す
     */
    getReviewAPICondition(reviewCountPerPool , poolCount , pageNum) {

      const params = {
      };

      const select1 = this.conditions.select1.filter(data => { return data.selected === true }).map(data => { return data.id });
      const select2 = this.conditions.select2.filter(data => { return data.selected === true }).map(data => { return data.id });
      const select3 = this.conditions.select3.filter(data => { return data.selected === true }).map(data => { return data.id });
      const select4 = this.conditions.select4.filter(data => { return data.selected === true }).map(data => { return data.age });
      const order = this.conditions.order.filter(data => { return data.selected === true }).map(data => { return data.num });
      const brand = this.conditions.brand.filter(data => { return data.selected === true }).map(data => { return data.text });

      // console.log("--------------------");
      // console.log(`conditions: ${JSON.stringify(this.conditions)}`);
      // console.log("--------------------");
      // console.log(`select1: ${JSON.stringify(select1)}`);
      // console.log(`select2: ${JSON.stringify(select2)}`);
      // console.log(`select3: ${JSON.stringify(select3)}`);
      // console.log(`select4: ${JSON.stringify(select4)}`);
      // console.log(`order: ${JSON.stringify(order)}`);
      // console.log(`brand: ${JSON.stringify(brand)}`);
      // console.log("--------------------");

      params['pl_worrisome'] = select1.join(",");
      params['pl_skincare'] = select2.join("");
      params['pl_makeup'] = select3.join("");
      params['pl_age'] = select4.join("");
      params['pl_sort'] = order.join("");
      if(brand.length > 0){
        params['pl_brand_name'] = brand.join(",");
      }

      params['pl_review_count'] = reviewCountPerPool; // プール毎のレビュー最大返却数
      params['pl_pool_count'] = poolCount; // 1ページ当りのプール数
      params['pl_pool_index'] = pageNum; // ページ番号

      // console.log("--------------------")
      // console.log(`params: ${JSON.stringify(params)}`);
      // console.log("--------------------")

      return params;
    },


    /**
     * レビューAPIからレビューデータを取得する
     * レビューはプール単位で配列に格納されている
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    getReviewData(params){
      return axios.get('https://www.shiseido.co.jp/wpmember/review/voicesforyou/api/getReviewList.php', {
        params: params,
        'withCredentials' : true
      }).then((res)=>{
        return res.data.data;
      })
    },

    /**
     * プールコードから商品データを取得する
     * @param poolCodesStr
     * @returns {Promise<AxiosResponse<any>>}
     */
    getProductDataByPoolCodeStr(poolCodesStr){
      return axios.get('https://www.shiseido.co.jp/sw/api/auth/V1/SWFR070210.seam',{
        params: {
          shohin_pl_c_cd: poolCodesStr
        }
      }).then((res)=>{
        return res.data;
      })
    },


    getValidCategoryProductData(productListData , validCategories){
      const validProducts = [];

      for(let i=0;i<productListData.length;i++){
        const data = productListData[i];
        const shohinCategoryName = data.shohin_ctgry_mei;

        if(validCategories.indexOf(shohinCategoryName) > -1){
          validProducts.push(data);
        }
      }
      return validProducts;
    },


    fixScrollPosition(){
      requestAnimationFrame(()=>{
          window.scroll({top: this.scrollPosition});
      });
    },
    
    /**
     * APIでデータを取得する 
     */
    getApiData() {
      this.isLockApi = true;
      this.showLoading = true;

      const params = this.getReviewAPICondition(this.maxReviewCountPerPool , this.poolCountPerView , this.pageNum);

      this.getReviewData(params).then((reviewData) => {

        console.log("-------------------- レビュー(商品)件数 --------------------");
        console.log(reviewData.length);


        // 該当の条件での返却商品レビュー件数が0の場合、追加読み込みなしで処理終了
        if(reviewData.length === 0){
          console.log("Request stop : レビュー0件");
          this.showLoading = false;
          this.isShowResult = true;
          this.moreApiEnd = true;
          return;
        }


        // 該当の条件での返却商品レビュー件数が1画面あたりの最大レビュー件数より少ない場合、追加読み込みなしフラグ立て、処理続行
        if (reviewData.length < this.poolCountPerView){
          console.log(`Request stop : レビュー件数が1画面あたりの最大レビュー件数 ${this.poolCountPerView}件 以下`);
          this.moreApiEnd = true; // もう読み込めない時フラグ変更
        }

        const poolCodes = reviewData.map((data)=>{
          return data['pool_code'];
        })

          console.log("-------------------- poolCodes --------------------");
          console.log(poolCodes);

          return this.getProductDataByPoolCodeStr(poolCodes.join(",")).then(({status, details, shohin_list: prodDataList})=>{

            if(status && status === 500){
              console.error("商品データ取得エラー");
              console.error(details);

              if(reviewData.length === this.poolCountPerView){
                console.log("Request Next Page");
                return this.requestMoreData();
              }else{
                this.showLoading = false;
                this.isLockApi = false;
                this.moreApiEnd = true;
                return;
              }
            }


            console.log("-------------------- 取得できた商品データ数 --------------------");
            console.log(prodDataList.length);
            // console.log(`${JSON.stringify(prodDataList)}`);

            const validCategoryProductData = this.getValidCategoryProductData(prodDataList , this.validCategories);

            console.log("-------------------- 有効なカテゴリの商品データ数 validCategoryProductData.length --------------------");
            console.log(validCategoryProductData.length);


            const validReviewData = validCategoryProductData.map((data)=>{
              const reviewIndex = poolCodes.indexOf(data.shohin_pl_c_cd);
              return Object.assign({}, reviewData[reviewIndex], data)
            });

            // console.log(validReviewData);

            if(validReviewData.length > 0){

              this.scrollPosition = window.scrollY;
              this.onUpdateProcessing = true;
              this.resultData = this.resultData.concat(validReviewData);

            }else if(reviewData.length === this.poolCountPerView){
              console.log("valid review data no match.");
              console.log("Request Next Page");
              return this.requestMoreData();
            }



            console.log(`this.moreApiEnd : ${this.moreApiEnd} validReviewData.length : ${validReviewData.length}  this.poolCountPerView : ${this.poolCountPerView}`);

            // 現在の結果データ数が、1画面あたりの最大レビュー件数より少ない場合、追加読み込み
            if(this.moreApiEnd === false && this.resultData.length < this.poolCountPerView){
               console.log("Request Next Page");
                setTimeout(()=>{
                  return this.requestMoreData();
                },100);

            }else{
              console.log("Request Stop");
              this.isShowResult = true;
              this.showLoading = false;
              this.isLockApi = false;

            }

          });

        })
        .catch(err => {
          console.error(err);
          this.isLockApi = false;
          this.showLoading = false;
        });

    },

    /**
     * APIでデータを追加で取得する 
     */
    requestMoreData() {
      console.log("-------------------- requestMoreData --------------------");
      this.pageNum++;
      this.getApiData();
    },


    /**
     * APIでデータを追加で取得する際の発火スクロールイベント
     */
    initializeScrollHandler() {
      const screenHeight = window.innerHeight;
      const apperPoint = screenHeight * 0.7;
      const element = document.querySelector(".moreApiBtn");

      window.addEventListener("scroll", ()=> {
        if(this.isShowResult){
          const elementHeightTotop = element.getBoundingClientRect().top;
          // console.log(`elementHeightTotop : ${elementHeightTotop} apperPoint : ${apperPoint}`);
          if(elementHeightTotop < apperPoint){
            // console.log("scroll------");
            console.log(`isShowResult : ${this.isShowResult} isLockApi ${this.isLockApi} moreApiEnd ${this.moreApiEnd}`);
            if (!this.isLockApi && !this.moreApiEnd){
              this.requestMoreData();
            }
          }
        }
      });
    },
   
   
    /**
     * 結果を並び替える
     */
    sortOrder() {

      this.preformedList.sort((a, b) => b.LatestDate - a.LatestDate);
      this.preformedList.forEach(item => item.visible = false);
      this.preformedList.sort((a,b) => {
        switch (this.selectedOrderID) {
          case 'new':
            return b.LatestDate - a.LatestDate;
          case 'old':
            return a.oldDate - b.oldDate;
          case 'high':
            return b.recommendation - a.recommendation;
          case 'low':
            return a.recommendation - b.recommendation;
        }
      })
      const _brand = this.conditions.brand.filter(item => { if (item.selected) return item.text });
      const _skincare = this.conditions.skincare.filter(item => { if (item.selected) return item.text });
      const _base = this.conditions.base.filter(item => { if (item.selected) return item.text });
      const _type = _skincare.concat(_base);
      if (_brand.length > 0 || _type.length > 0) {
        this.preformedList.forEach(list => {
          if (_brand.length > 0) {
            if (_type.length > 0) {
              _brand.forEach(item1 => {
                _type.forEach(item2 => {
                  if (item1.text.indexOf(list.brand) !== -1 && item2.text.indexOf(list.category) !== -1) list.visible = true;
                })
              })
            } else {
              _brand.forEach(item => {
                if (item.text.indexOf(list.brand) !== -1) list.visible = true;
              })
            }
          } else {
            if (_type.length > 0) {
              _type.forEach(item => {
                if (item.text.indexOf(list.category) !== -1)  list.visible = true;
              })
            }
          }
        });
      } else {
        this.preformedList.forEach(item => item.visible = true);
      }

    },

    /**
     * 条件を絞り込む
     * @param index {Number} 選択した要素の配列の中の順番
     * @param type {String} 選択した要素が存在する配列
     */
    sortSelect(index, type) {
      if (type === 'order') {
        for (let _index = 0; _index < this.conditions.order.length; _index++) {
          this.conditions.order[_index].selected = false;
        }
        this.conditions[type][index].selected = true;
      }
      if (type === 'brand' || type === 'skincare' || type === 'base') {
        this.conditions[type][index].selected = !this.conditions[type][index].selected;
      }
      this.isSortOrder = true;
      this.sortOrder();
    },


    /**
     * RETRYボタンが押されたら
     */
    clickedRetry() {
      this.clearCheckBox();
      window.scrollTo(0, 0);
      this.$emit('clickedRetry');
    },



    /**
     * 全てのレビューをもっと見る2
     */
    moreReview(item,index) {
      item.comment_all_view = true;
      this.$set(this.resultData , index, item);
    },    

    /**
     * 絞り込みチェックボックスを初期化する
     */
    clearCheckBox() {
      for (let _index of Object.keys(this.conditions)) {
        this.conditions[_index].forEach((item,i) => {
          // console.log(this.conditions[_index][i], this.conditions[_index][i].selected);
          this.$set(this.conditions[_index][i], 'selected', false);
          // item.selected = false;
        })
      }

      this.$set(this.conditions.order[0], 'selected', true);
      // this.conditions.order[0].selected = true;
      this.$refs.sort.hide();
    },

    /**
     * 選択肢を返す
     */
    sortChoices(status) {
      this.$emit('sortChoices', status);
    }
  },

  watch: {
    resultData() {
      this.$nextTick(() => {
        if(this.onUpdateProcessing){
          // console.log("update scroll position");
          this.fixScrollPosition();
          this.onUpdateProcessing = false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.result {
  @include media() {
    min-height: calc(100vh - 274px);
  }
  &-title {
    width: 298/375 * 100%;
    margin: 0 auto;
    @include media() {
      width: 558px;
    }
  }
  &-text {
    width: 295/375 * 100%;
    margin: 30/375 * 100% auto 0;
    font-size: 12/375 * 100vw;
    line-height: (17/10);
    letter-spacing: .05em;
    @include media() {
      text-align: center;
      width: 670px;
      margin: 40px auto 0;
      font-size: 13px;
      line-height: (28/13);
    }
  }
  &-scroll {
    width: 1px;
    height: 106/375 * 100vw;
    position: fixed;
    right: 18.75/375 * 100%;
    bottom: 0;
    z-index: 1;
    opacity:1;
    transition:opacity 600ms ease-in-out;

    @include media() {
      height: 147px;
      right: 40px;
    }
    &.is-absolute {
      position: absolute;
      opacity:0;
    }
    &::before {
      content: '';
      display: block;
      width: 1px;
      height: 40/106 * 100%;
      background: #333;
      position: absolute;
      top: 66/106 * 100%;
      right: 52%;
      animation: scroll_shrink 3s linear infinite both;
      @keyframes scroll_shrink {
        0% {
          height: 0;
          top: 66/106 * 100%;
        }
        45% {
          height: 40/106 * 100%;
          top: 66/106 * 100%;
        }
        95% {
          height: 40/106 * 100%;
          top: 100%;
        }
        96% {
          height: 0;
          top: 100%;
        }
        100% {
          height: 0;
          top: 66/106 * 100%;
        }
      }
    }
    &-text {
      width: 51/375 * 100vw;
      transform: rotate(90deg);
      transform-origin: left;
      @include media() {
        width: 72px;
      }
    }
  }
  &-wrap {
    width: 295/375 * 100%;
    margin: 20/375 * 100% auto 0;
    @include media() {
      max-width: 800px;
      margin: 20px auto 0;
    } 
  }
  &-view {
    display: none;
    &.is-visible {
      display: block;
    }
  }
  &-item {
    margin: 20/295 * 100% 0;
    border-top: 1px solid #333;
    @include media() {
      margin: 30px 0;
    }
  }
  &-comments {
    &-comment {
      background: rgba(255, 255, 255, .8);
      margin-top: 15/295 * 100%;
      @include media() {
        margin-top: 20px;
        position: relative;
      }
      &:not(:first-child){
        .result-comments--multiple & {
          display: none;
        }
        .result-comments--multiple.result-comments--view & {
          display: block;
        }
      }
    }
    &-more {
      display: block;
      margin: 15/295 * 100% auto 0;
      color: #DF0168;
      font-size: 12/375 * 100vw;
      @include media() {
        margin: 20px auto 0;
        font-size: 14px;
        cursor: pointer;
        transition: .15s ease;
        &:hover {
          opacity: .8;
        }
      }
    }
  }
  &-loading {
    border-top: 1px solid #333;
    padding-top: 20/295 * 100%;
    visibility: hidden;

    &.is-active{
      visibility: visible;
    }

    @include media() {
      margin-top: 30px;
      padding-top: 30px;
    }
    &-dot {
      width: 4/295 * 100%;
      margin-left: auto;
      margin-right: auto;
      padding-top: 4/295 * 100%;
      border-radius: 50%;
      background: #DF0168;
      @include media() {
        width: 6px;
        padding-top: 6px;
      }
      &:not(:first-child) {
        margin-top: 7/295 * 100%;
        @include media() {
          margin-top: 10px;
        }
      }
    }
  }
  &-nothing {
    text-align: center;
    padding-top: 2em;
    font-size: 11/375 * 100vw;
    line-height: (18/11);
    @include media() {
      font-size: 13px;
    }
    &-button {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 160/295 * 100%;
      border: 1px solid #DF0168;
      margin: 30/295 * 100% auto 0;
      padding: 10/295 * 100% 0;
      border-radius: 20/375 * 100vw;
      @include media() {
        width: 200px;
        margin: 120px auto 0;
        padding: 14px 0;
        cursor: pointer;
      }
      &-arrow {
        width: 10.86/375 * 100vw;
        height: 12/375 * 100vw;
        margin-right: 5.2/375 * 100vw;
        fill: #DF0168;
        @include media() {
          width: 13px;
          height: 14px;
          margin-right: 5px;
        }
      }
      &-text {
        color: #DF0168;
        font-size: 12/375 * 100vw;
        line-height: (18/12);
        letter-spacing: .1em;
        @include media() {
          font-size: 14px;
          line-height: (20/14);
          transition: .45s ease;
          .result-nothing-button:hover & {
            letter-spacing: .3em;
          }
        }
      }
    }
  }
}
.moreApiBtn {
  opacity: 0;
  pointer-events: none;
}
</style>
